import { LOGIN_STEPS, LoginLessState, OTP_METHODS } from '@/data/Content/Login';
import { FC, Fragment } from 'react';
import { Switch } from '@/utils/switch';
import { InitialLogonIdStage } from '@/components/blocks/SingleLoginLessForm/parts/InitialLogonIdStage';
import { SelectOtpMethodStage } from '@/components/blocks/SingleLoginLessForm/parts/SelectOtpMethodStage';
import { LoginOtpStage } from '@/components/blocks/SingleLoginLessForm/parts/LoginOtpStage';
import { LoginPasswordStage } from '@/components/blocks/SingleLoginLessForm/parts/LoginPasswordStage';

type Props = {
	stateLogin: LoginLessState;
	disabled?: boolean;
	baseSettings: {
		emailSendCooldownSeconds: number;
		phoneSendCooldownSeconds: number;
	};
	showInDialog?: boolean;
	onChangeLogonId: (logonId: string) => void;
	onBlurLogonId: () => void;
	onSubmitInitialLogonId: () => void;
	onChangeOtpMethod: (otpMethod: OTP_METHODS) => void;
	onSubmitOtpMethod: () => void;
	onChangeOtp: (otp: string) => void;
	onChangePassword: (password: string) => void;
	onSubmitLogin: () => void;
	onToggleLoginPassword: () => void;
	onToggleSelectOtpMethod: () => void;
	onGoogleLogin?: (idToken: string) => void;
};

export const SingleLoginLessForm: FC<Props> = ({
	stateLogin,
	disabled,
	baseSettings,
	showInDialog,
	onChangeLogonId,
	onBlurLogonId,
	onSubmitInitialLogonId,
	onChangeOtpMethod,
	onSubmitOtpMethod,
	onChangeOtp,
	onSubmitLogin,
	onToggleLoginPassword,
	onChangePassword,
	onToggleSelectOtpMethod,
	onGoogleLogin,
}) => (
	<Fragment>
		{Switch(stateLogin.step)
			.case(LOGIN_STEPS.INITIAL_LOGON_ID, () => (
				<InitialLogonIdStage
					logonId={stateLogin.logonId}
					logonIdError={stateLogin.logonIdError}
					disabled={stateLogin.submitting || disabled}
					showInDialog={showInDialog}
					onChangeLogonId={onChangeLogonId}
					onBlurLogonId={onBlurLogonId}
					onSubmitInitialLogonId={onSubmitInitialLogonId}
					onGoogleLogin={onGoogleLogin}
				/>
			))
			.case(LOGIN_STEPS.SELECT_OTP_METHOD, () => (
				<SelectOtpMethodStage
					otpMethod={stateLogin.otpMethod}
					otpMethodError={stateLogin.otpMethodError}
					disabled={stateLogin.submitting || disabled}
					maskedPhone={stateLogin.maskedPhone}
					maskedEmail={stateLogin.maskedEmail}
					password={stateLogin.password}
					passwordError={stateLogin.passwordError}
					onChangePassword={onChangePassword}
					onChangeOtpMethod={onChangeOtpMethod}
					onSubmitOtpMethod={onSubmitOtpMethod}
					onToggleLoginPassword={onToggleLoginPassword}
				/>
			))
			.case(LOGIN_STEPS.LOGIN_OTP, () => (
				<LoginOtpStage
					otp={stateLogin.otp}
					otpError={stateLogin.otpError}
					disabled={stateLogin.submitting || disabled}
					sendCooldownSeconds={
						stateLogin.otpMethod === OTP_METHODS.EMAIL
							? baseSettings.emailSendCooldownSeconds
							: baseSettings.phoneSendCooldownSeconds
					}
					cooldownStartedAt={stateLogin.lastOtpSentAt}
					onChangeOtp={onChangeOtp}
					onSubmitLogin={onSubmitLogin}
					onSubmitOtpMethod={onSubmitOtpMethod}
					onToggleSelectOtpMethod={onToggleSelectOtpMethod}
				/>
			))
			.case(LOGIN_STEPS.LOGIN_PASSWORD, () => (
				<LoginPasswordStage
					logonId={stateLogin.logonId}
					logonIdError={stateLogin.logonIdError}
					password={stateLogin.password}
					passwordError={stateLogin.passwordError}
					disabled={stateLogin.submitting || disabled}
					onChangeLogonId={onChangeLogonId}
					onBlurLogonId={onBlurLogonId}
					onChangePassword={onChangePassword}
					onSubmitLogin={onSubmitLogin}
					onToggleSelectOtpMethod={onToggleSelectOtpMethod}
				/>
			))
			.defaultTo(() => null)}
	</Fragment>
);
